import React, { useState, useEffect } from 'react'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import FilterHistory from '../../../widgets/history/FilterHistory'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getFilterHistory } from '../../../redux/actions/history'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getProposalForm } from '../../../redux/actions/filesManagement'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import scrollToComponent from 'react-scroll-to-component'
import { Row } from 'rsuite'
import ScreenHistory from '../../../widgets/history/ScreenHistory'

export default function ProposalFilterHistory() {
  const [isLoading, setIsLoading] = useState(false)
  const [isPreview, setIsPreview] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [pdfRender, setPdfRender] = useState()
  const [section, setSection] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load ProposalFilterHistory projectId', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getFilterHistory(projectId)
      // console.log('ProposalFilterHistory response : ', JSON.stringify(response))
      setSchema(response)
      // setSchema(mock)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handlePreview = async (id) => {
    startLoading()

    try {
      const filePDF = await getProposalForm(id)
      setPdfRender(filePDF)
      console.log('filePDF', filePDF)
    } catch (e) {
      console.log('e', e)
    }

    doneLoading()
  }

  const onPreview = (Obj) => {
    console.log('onPreview', Obj)

    setIsPreview(true)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
    // handlePreview('9BE3B891-FD65-416B-8459-7AD624B5D3F2')
    handlePreview(Obj.id)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ScreenHistory
        header={schema.header}
        schema={schema.history}
        // onPreview={onPreview}
      />
      <br />

      <Row
        ref={(section) => {
          setSection(section)
        }}
      ></Row>

      {isPreview && (
        <>
          <PdfRenderWidgets
            header={'แสดงตัวอย่างก่อนพิมพ์ ข้อเสนอโครงการ'}
            file={pdfRender}
            isLoading={isLoading}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}

// const mock = {
//   header: 'ประวัติการคัดกรอง',
//   subHeader: '',
//   history: {
//     dateTimeTitle: 'วันที่เวลา',
//     agencyTitle: 'หน่วยงาน',
//     screenTypeTitle: 'ประเภทคัดกรอง',
//     screenerTitle: 'ผู้คัดกรอง',
//     coordinatorTitle: 'ผู้ประสานงาน',
//     commentTitle: 'ข้อคิดเห็น',
//     tableData: [
//       {
//         dateTime: '09 มี.ค. 2564 15:08 น.',
//         agency: 'สน.9',
//         screenType: 'คัดกรอง',
//         screener: 'นายมานะ มีบุญ',
//         coordinator: 'นางเพ็ญสี ใจดี',
//         comment: 'Test',
//       },
//       {
//         dateTime: '07 มี.ค. 2564 15:08 น.',
//         agency: 'สน.6',
//         screenType: 'คัดกรองขั้นต้น',
//         screener: 'นายสมชาย สมหญิง',
//         coordinator: 'นางเพ็ญสี ใจดี',
//         comment: 'เข้าข่าย สน.9',
//       },
//     ],
//   },
// }
